import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import mineCraftApi from '../../api/mineCraftApi';
import minecraftUrls from "../../configs/mine_craft/minecraftUrls";
import { TipInterface } from "../../store/mine_craft/tipsSlice";

const processStrategy = (value: any) => {
  return {
    ...value,
    url: minecraftUrls.tipPath(value.id),
    thumbnail_url: minecraftUrls.remoteUrl(value.thumbnail_url),
    saven_image_url: minecraftUrls.remoteUrl(value.saven_image_url)
  };
}

const tipsEntity = new schema.Entity(
  'tips',
  {},
  {
    processStrategy
  }
);

const tipEntity = new schema.Entity(
  'tip',
  {},
  {
    processStrategy
  }
);

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<any, { tip: TipInterface }>(response.data.tip, tipEntity);
  return normalized.entities;
}

export const fetchTips = createAsyncThunk(
  'tips/fetchTips',
  async (params: object = {}) => {
    const response    = await mineCraftApi.get(`/onesky/tips`, { params })
    const normalized  = normalize<any, { tips: { [key: string]: TipInterface } }>(response.data.tips, [tipsEntity]);

    return {
      tips: normalized.entities?.tips || {},
      ids: normalized.result,
      count: response.data.meta?.total_count
    };
  }
);

export const fetchTip = createAsyncThunk(
  'tips/fetchTip',
  async (id: number | string) => {
    const response = await mineCraftApi.get(`/onesky/tips/${id}`);
    return normalizeInstance(response);
  }
);

export const createTip = createAsyncThunk(
  'tips/createTip',
  async (data: object, { rejectWithValue }) => {
    try {
      const response = await mineCraftApi.post(`/onesky/tips`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

export const updateTip = createAsyncThunk(
  'tips/updateTip',
  async ({ id, data }: { id: number, data: object }, { rejectWithValue }) => {
    try {
      const response = await mineCraftApi.patch(`/onesky/tips/${id}`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);

export const destroyTip = createAsyncThunk(
  'tips/destroyTip',
  async (id: number) => {
    await mineCraftApi.delete(`/onesky/tips/${id}`);
    return { id: id };
  }
);

export const reorderTips = createAsyncThunk(
  'tips/reorderTips',
  async ({ ids }: { ids: any }, { rejectWithValue }) => {
    try {
      await mineCraftApi.patch('/onesky/tips/reorder', { ids })

      return { ids };
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);
